export default __webpack_public_path__ + "static/xometry-logo-big-ideas-212f068d03424b79aae4954a8aca4e38.jpeg";